import React, { useState, useEffect } from "react";
import { defineMessages } from "react-intl";
import RadioFormGroup from "assets/scripts/components/common/form/RadioFormGroup/RadioFormGroup";
const messages = defineMessages({
    proceedEnglish: {
        id: "forms.profile.language.proceedEnglish",
        defaultMessage: "Yes, proceed in English"
    },
    proceedSpanish: {
        id: "forms.profile.language.proceedSpanish",
        defaultMessage: "Yes, proceed in Spanish"
    },
    dontProceed: {
        id: "forms.profile.language.dontProceed",
        defaultMessage: "No, I do not wish to proceed."
    },
    question: {
        id: "forms.profile.language.proceedQuestion",
        defaultMessage: "We apologize, our site does not support your language preference. "
            + "Do you wish to proceed in English or Spanish?"
    }
});
const options = [
    {
        value: "English",
        label: messages.proceedEnglish
    },
    {
        value: "Spanish",
        label: messages.proceedSpanish
    },
    {
        value: "Other",
        label: messages.dontProceed
    },
];
export default function ProfileLanguageOther(props) {
    const [otherLang] = useState(props.value.languagePreference);
    const [option, setOption] = useState("English");
    useEffect(() => {
        if (option === "English" || option === "Spanish") {
            props.onChange({ languagePreference: option });
            return;
        }
        props.onChange({ languagePreference: otherLang });
    }, [option, otherLang]);
    return (<RadioFormGroup name="language" label={messages.question} value={option} onChange={setOption} options={options} vertical/>);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/profile/ProfileForm/ProfileLanguageInputs/ProfileLanguageOther.tsx